@if (name()) {
  <h2 class="text-2xl font-bold mb-2">{{ name() }}</h2>
  <div class="flex flex-col justify-start items-start gap-4">
    @if (price()) {
      <div class="flex justify-start items-start gap-4 py-4">
        <app-ui-icon color="var(--grey-0)" name="card"
                  size="md"></app-ui-icon>

        <div>
          <div class="font-bold">
            @if (isFromPrice()) {
              från
            }
            {{ price() }}kr
          </div>
          @if (priceDescription()) {
            <div>{{ priceDescription() }}</div>
          }
        </div>
      </div>
    }
  </div>
  @if (description()) {
    <div [innerHtml]="description()" class="description"></div>
  }

}

